import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import { Prompt } from 'react-router';
import SettingControlsBlock from '../../../../containers/SettingControlsBlock/SettingControlsBlock';
import NotificationSettingEditMainBlock from '../../containers/NotificationSettingEditMainBlock/NotificationSettingEditMainBlock';
import NotificationSettingEditTopBlock from '../../containers/NotificationSettingEditTopBlock/NotificationSettingEditTopBlock';
import { NotificationsSettingType } from '../../constants/notifications';
import { orderStatusNotificationSettingEventPickerOptions, orderStatusNotificationSettingShortCodePickerOptions } from './constants';
import { orderStatusNotificationEditStore } from './store';
import { SCREENS } from 'src/constants/screens';
import { getPromptProps } from 'src/view/components/CustomPrompt/helper';
import LoadingOverlay from 'src/view/components/LoadingOverlay/LoadingOverlay';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import Headers from 'src/view/containers/Headers/Headers';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';

const OrderStatusNotificationEditScreen: FC = observer((): JSX.Element => {
  useEffect(() => {
    orderStatusNotificationEditStore.initStore();
  }, []);

  return (
    <div className="d-flex flex-column flex-1">
      <Headers>
        <HeaderBack title="create_new_notification" path={SCREENS.SETTINGS_NOTIFICATIONS_ORDER_STATUS()} isBeta />
      </Headers>

      <ScrollableBlock showScrollbar scrollbarSize="normal" className="flex-1 mt-6" scrollClassName="d-flex flex-column gap-30">
        <NotificationSettingEditTopBlock
          type={NotificationsSettingType.ORDER}
          eventPickerOptions={orderStatusNotificationSettingEventPickerOptions()}
          notification={orderStatusNotificationEditStore.notification}
          changeNotification={orderStatusNotificationEditStore.changeNotification}
        />
        <NotificationSettingEditMainBlock
          shortCodePickerOptions={orderStatusNotificationSettingShortCodePickerOptions()}
          subject={orderStatusNotificationEditStore.notification.subject}
          message={orderStatusNotificationEditStore.notification.message}
          subjectValidation={orderStatusNotificationEditStore.validation.subject}
          messageValidation={orderStatusNotificationEditStore.validation.message}
          changeNotification={orderStatusNotificationEditStore.changeNotification}
        />
        <SettingControlsBlock
          redirectPath={SCREENS.SETTINGS_NOTIFICATIONS_ORDER_STATUS()}
          setValidation={orderStatusNotificationEditStore.setValidation}
          onSubmit={orderStatusNotificationEditStore.createNotification}
          onReset={orderStatusNotificationEditStore.resetNotification}
        />
      </ScrollableBlock>

      <LoadingOverlay visible={orderStatusNotificationEditStore.isLoading} />
      <Prompt when={orderStatusNotificationEditStore.isEdit} message={getPromptProps()} />
    </div>
  );
});

export default OrderStatusNotificationEditScreen;
